export const serverUrl="https://inv-manage.appspot.com/"

